export default "__VITE_ASSET__VAFnc71A__"